import { render, staticRenderFns } from "./DefaultParameters.vue?vue&type=template&id=b9bf33d0&"
import script from "./DefaultParameters.vue?vue&type=script&lang=js&"
export * from "./DefaultParameters.vue?vue&type=script&lang=js&"
import style0 from "./DefaultParameters.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports